﻿import React from 'react';

import { GroupCode } from 'components/GroupCode/GroupCode';
import { ToolTip } from 'components/ToolTip/ToolTip';
import { FormattedMessage } from 'react-intl';
import { Badge, Form } from 'react-bootstrap';

interface GroupCodeWrapperProps {
    archived?: boolean;
    codeToCopy?: string | undefined;
    infoTitle?: string;
    label?: string;
    labelClass?: string;
    showCode?: boolean;
    subLabel?: string;
}

export const GroupCodeWrapper = ({
    archived,
    codeToCopy,
    infoTitle,
    label,
    labelClass,
    showCode = true,
    subLabel

}: GroupCodeWrapperProps) => (
    <>
        {label && (
        <div className="d-flex align-items-center">
            <Form.Label className={`fw-bold ${labelClass ? labelClass : ''}`}>
                {label}
            </Form.Label>
            {subLabel && (
            <small className="text-muted ms-2 mb-2">
                {subLabel}
            </small>
            )}
            {infoTitle && <ToolTip className="mb-1" content={infoTitle} />}
        </div>
        )}
        <div className="d-flex align-items-center">
            {showCode &&
            <GroupCode code={codeToCopy} />
            }
            {archived && (
                <h3 className="ms-2">
                    <Badge pill bg="warning">
                        <FormattedMessage defaultMessage="Archived" id="archived.e57c14b9" />
                    </Badge>
                </h3>
            )}
        </div>
    </>
);